export const CompanyHelper = {
    Status: {
        Pending:0,
        Approved:1,
        Deleted:2,
    },
    Stamp: {
        None:0,
        Verified:1,
    },

    StatusList: [
        {name: "Pendente", value:0},
        {name: "Aprovada", value:1},
    ]
}